import { type FC } from "react";
import { OAuthCardError } from "@/pages/oauth-consent/oauth-card-error";

import { OAuthConsentPageForm } from "@/pages/oauth-consent/oauth-consent-page-form";
import type { OAuthCardProps } from "@/pages/oauth-consent/oauth-card";

interface OAuthConsentPageContentProps {
  redirectUri: string | null;
  clientId: string | null;
  state: string | null;
  scopeStr: string | null;
  responseType: string | null;
  appName: string;
  accountInfo: OAuthCardProps["accountInfo"];
  onApprove: () => Promise<void>;
  onDeny: () => Promise<void>;
}

export const OAuthConsentPageContent: FC<OAuthConsentPageContentProps> = ({
  redirectUri,
  clientId,
  state,
  scopeStr,
  responseType,
  appName,
  accountInfo,
  onApprove,
  onDeny,
}) => {
  if (!redirectUri || !clientId || !state || !scopeStr || responseType !== "code") {
    return <OAuthCardError />;
  }

  return (
    <OAuthConsentPageForm
      appName={appName}
      scopeStr={scopeStr}
      accountInfo={accountInfo}
      handleApprove={onApprove}
      handleDeny={onDeny}
    />
  );
};
